import React from "react"
import Icon from "../../Icon/Icon"

export default function CustomFields({
	jwtPublicKey,
	jwtIssuer,
	updateSettings,
}: {
	jwtPublicKey: string
	jwtIssuer: string | undefined
	updateSettings: (field: string, value: string) => void
}) {
	return (
		<fieldset className="fields">
			<div className="field">
				<div className="label-wrapper label-with-help">
					<label className="label">Public Key</label>
					<div className="help-elements">
						<Icon
							icon="information-circle--interface-essential"
							size={12}
							data-tip="React-tooltip"
							data-for="jwks-path-tooltip"
						/>
						<a className="jwks-button link" href="https://jwt.io/introduction" target="_blank" rel="noreferrer">
							How to find my JWKS
						</a>
					</div>
				</div>
				<div className="control">
					<textarea
						placeholder={`----- BEGIN KEY -----


----- END KEY -----`}
						className="textarea has-fixed-size"
						value={jwtPublicKey ?? ""}
						required
						onChange={(e) => {
							updateSettings("jwtPublicKey", e.target.value)
							if (e.target.validity.patternMismatch) {
								e.target.setCustomValidity(
									"invalid url, make sure your url is in this format: 'https://domain-name.auth0.com/jwks.json'"
								)
							} else {
								e.target.setCustomValidity("")
							}
						}}
					/>
					<div className="description">
						<svg
							viewBox="0 0 1024 1024"
							style={{
								stroke: "currentcolor",
								fill: "currentcolor",
								width: "12px",
								height: "12px",
							}}
						>
							<path d="M512 85.334c-235.641 0-426.666 191.025-426.666 426.666 0 235.643 191.025 426.665 426.666 426.665 235.643 0 426.665-191.022 426.665-426.665 0-235.641-191.022-426.666-426.665-426.666zM0 512c0-282.77 229.23-512 512-512 282.767 0 512 229.23 512 512 0 282.767-229.233 512-512 512-282.77 0-512-229.233-512-512z" />
							<path d="M554.665 298.666h-85.331v-85.334h85.331v85.334z" />
							<path d="M469.334 469.334h-85.334v-85.334h170.665v298.665h85.335v85.335h-256v-85.335h85.334v-213.331z" />
						</svg>
						<p>Remove BEGIN line, END line, and any line breaks.</p>
					</div>
				</div>
			</div>
			<div className="field">
				<label className="label">JWT Issuer</label>
				<div className="control">
					<input
						className="input"
						type="text"
						placeholder="Issuer"
						value={jwtIssuer ?? ""}
						onChange={(e) => {
							updateSettings("jwtIssuer", e.target.value)
						}}
					/>
				</div>
			</div>
		</fieldset>
	)
}
